// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Info Tooltip Styles */
.info-tooltip-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  margin-left: 1px;
  vertical-align: middle;
}

.info-tooltip-icon {
  font-size: 15px;
  color: #9e9e9e;
  cursor: pointer;
  transition: color 0.3s ease;
  position: relative;
}

.info-tooltip-icon:hover {
  color: #5616ea;
}

.info-tooltip {
  position: fixed;
  transform: translate(-50%, calc(-100% + 6px));
  opacity: 0;
  background: linear-gradient(135deg, #5616ea 0%, #7c3aed 100%);
  color: #fff;
  padding: 12px 16px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.5;
  white-space: normal;
  width: 280px;
  max-width: calc(100vw - 24px);
  min-height: 44px;
  text-align: left;
  box-shadow: 0 8px 24px rgba(86, 22, 234, 0.35), 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 99999;
  pointer-events: none;
  transition: opacity 0.18s ease, transform 0.18s ease;
  will-change: opacity, transform;
}

.info-tooltip-visible {
  opacity: 1;
  transform: translate(-50%, -100%);
}

/* Bottom placement: sits below the trigger (fade only, no slide). */
.info-tooltip-bottom,
.info-tooltip-bottom.info-tooltip-visible {
  transform: translate(-50%, 0);
}

/* Compact: short labels / titles (e.g. header icon buttons). */
.info-tooltip-compact {
  width: auto;
  min-height: 0;
  white-space: nowrap;
  padding: 6px 11px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.3;
}


/* Error variant: same shape and motion, red instead of brand purple. Used for
   "why did this fail" hovers (knowledgeStatus.js). */
.info-tooltip-error {
  background: linear-gradient(135deg, #b42318 0%, #d92d20 100%);
  box-shadow: 0 8px 24px rgba(180, 35, 24, 0.32), 0 4px 12px rgba(0, 0, 0, 0.15);
}
`, "",{"version":3,"sources":["webpack://./src/components/InfoTooltip.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,6CAA6C;EAC7C,UAAU;EACV,6DAA6D;EAC7D,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,8EAA8E;EAC9E,cAAc;EACd,oBAAoB;EACpB,oDAAoD;EACpD,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,iCAAiC;AACnC;;AAEA,oEAAoE;AACpE;;EAEE,6BAA6B;AAC/B;;AAEA,+DAA+D;AAC/D;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;;AAGA;qDACqD;AACrD;EACE,6DAA6D;EAC7D,8EAA8E;AAChF","sourcesContent":["/* Info Tooltip Styles */\r\n.info-tooltip-wrapper {\r\n  position: relative;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  margin-left: 1px;\r\n  vertical-align: middle;\r\n}\r\n\r\n.info-tooltip-icon {\r\n  font-size: 15px;\r\n  color: #9e9e9e;\r\n  cursor: pointer;\r\n  transition: color 0.3s ease;\r\n  position: relative;\r\n}\r\n\r\n.info-tooltip-icon:hover {\r\n  color: #5616ea;\r\n}\r\n\r\n.info-tooltip {\r\n  position: fixed;\r\n  transform: translate(-50%, calc(-100% + 6px));\r\n  opacity: 0;\r\n  background: linear-gradient(135deg, #5616ea 0%, #7c3aed 100%);\r\n  color: #fff;\r\n  padding: 12px 16px;\r\n  border-radius: 10px;\r\n  font-size: 13px;\r\n  font-weight: 400;\r\n  line-height: 1.5;\r\n  white-space: normal;\r\n  width: 280px;\r\n  max-width: calc(100vw - 24px);\r\n  min-height: 44px;\r\n  text-align: left;\r\n  box-shadow: 0 8px 24px rgba(86, 22, 234, 0.35), 0 4px 12px rgba(0, 0, 0, 0.15);\r\n  z-index: 99999;\r\n  pointer-events: none;\r\n  transition: opacity 0.18s ease, transform 0.18s ease;\r\n  will-change: opacity, transform;\r\n}\r\n\r\n.info-tooltip-visible {\r\n  opacity: 1;\r\n  transform: translate(-50%, -100%);\r\n}\r\n\r\n/* Bottom placement: sits below the trigger (fade only, no slide). */\r\n.info-tooltip-bottom,\r\n.info-tooltip-bottom.info-tooltip-visible {\r\n  transform: translate(-50%, 0);\r\n}\r\n\r\n/* Compact: short labels / titles (e.g. header icon buttons). */\r\n.info-tooltip-compact {\r\n  width: auto;\r\n  min-height: 0;\r\n  white-space: nowrap;\r\n  padding: 6px 11px;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  line-height: 1.3;\r\n}\r\n\r\n\r\n/* Error variant: same shape and motion, red instead of brand purple. Used for\r\n   \"why did this fail\" hovers (knowledgeStatus.js). */\r\n.info-tooltip-error {\r\n  background: linear-gradient(135deg, #b42318 0%, #d92d20 100%);\r\n  box-shadow: 0 8px 24px rgba(180, 35, 24, 0.32), 0 4px 12px rgba(0, 0, 0, 0.15);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
